import List from "@/components/list";
import { Confirm } from "@/components/Confirm";
const Table = args => {
  const { listeners, parent } = args;

  const RCSelectionChange = listeners["selection-change"] || function () { };
  // 删除人员
  async function deletePerson(person) {
    try {
      await Confirm("确定删除该人员吗?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      parent.persons.splice(parent.persons.indexOf(person), 1);
      parent.getCurrentPersons();
    } catch (error) {
      if (error === "cancel") return;
    }
  }

  const Deal = ({ props: { vo } }) => {
    const person = vo.row;
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => {
          deletePerson(person);
        }
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip width="50%" content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig =
    parent.form.messageForm.mqUserType === 0
      ? (parent.form.messageForm.mqInfoType == 6 
        ? [
          {
            type: "selection",
            label: "main"
          },
          {
            label: "联络员姓名",
            prop: "toUserName"
          },
          {
            label: "联络员手机号",
            prop: "toUserMobile"
          },
          {
            label: "管理的学员名单",
            prop: "classEnrollNames"
          },
          {
            label: "操作",
            render: vo => <Deal vo={vo} />
          }
        ]:[
        {
          type: "selection",
          label: "main"
        },
        {
          label: "姓名",
          prop: "userName"
        },
        {
          label: "手机号",
          prop: "userMobile"
        },
        {
          label: "所属单位",
          prop: "deptName"
        },
        {
          label: "单位及职务",
          prop: "unitPosition"
        },
        {
          label: "是否考核",
          prop: "isExamName"
        },
        {
          label: "用户状态",
          prop: "userStatusName"
        },
        {
          label: "操作",
          render: vo => <Deal vo={vo} />
        }
      ]): [
        {
          type: "selection",
          label: "main"
        },
        {
          label: "姓名",
          prop: "userName"
        },
        {
          label: "手机号",
          prop: "userMobile"
        },
        {
          label: "操作",
          render: vo => <Deal vo={vo} />
        }
      ];
  return (
    <List
      {...args}
      empty-text={`尚未添加任何群发用户，点击右上角【名单管理】${parent.form.messageForm.mqInfoType !== 6 ? "或【导入名单】": ""}进行维护`}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
